export enum CompensationDeviationTendancy {
  HugeGapBelow = 'HugeGapBelow',
  SmallGapBelow = 'SmallGapBelow',
  InExpectationBelow = 'InExpectationBelow',
  InExpectationAbove = 'InExpectationAbove',
  SmallGapAbove = 'SmallGapAbove',
  HugeGapAbove = 'HugeGapAbove'
}
